import PropTypes from 'prop-types'
import { applySpec, pipe, propOr } from 'ramda'
import s3LinkParser from '../../utils/s3-link'

const File = applySpec({
  id: propOr('', 'id'),
  name: propOr('', 'fileName'),
  type: propOr('', 'fileType'),
  size: propOr(0, 'fileSize'),
  url: pipe(propOr('', 'location'), s3LinkParser),
  data: propOr({}, 'data'),
})

export const FilePropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
})

export default File
